import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  model,
  OnDestroy,
  OnInit,
  viewChild,
} from '@angular/core';
import { IonAccordionGroup, IonicModule } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';

/**
 * Component Accordion qui s'ouvre / se ferme
 *
 * @export
 * @class AccordionComponent
 */
@Component({
  selector: 'accordion',
  templateUrl: 'accordion.component.html',
  standalone: true,
  styleUrls: ['./accordion.component.scss'],
  imports: [IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent implements OnInit, OnDestroy, AfterViewInit {
  private el = inject(ElementRef);
  closed = model<boolean>(false);

  private toggleOpenSubscription: Subscription;
  forceOpen = input<Observable<string>>();

  title = input<string>();
  color = input<string>();
  colorIcon = input<string>();
  colorLeftIcon = input<string>();
  colorTitle = input<string>();
  icon = input<string>();
  sizeTitle = input<string>('16px');
  accordionGroup = viewChild<IonAccordionGroup>('accordionGroup');

  ngOnInit() {
    if (this.forceOpen()) {
      this.toggleOpenSubscription = this.forceOpen().subscribe((element_id: string) => {
        if (element_id !== null && !this.checkIfIdExists(element_id)) {
          return;
        }
        this.accordionGroup().value = 'item';
      });
    }
  }

  ngAfterViewInit() {
    // fix(DT-29780)
    setTimeout(() => {
      this.accordionGroup().value = this.closed() ? undefined : 'item';
    }, 0);
  }

  private checkIfIdExists(id: string): boolean {
    return !!this.el.nativeElement.querySelector(`#${id}`);
  }

  ngOnDestroy() {
    if (this.toggleOpenSubscription) {
      this.toggleOpenSubscription.unsubscribe();
    }
  }

  markAsToggled(event: any) {
    const nativeEl = this.accordionGroup();
    this.closed.set(nativeEl.value !== 'item');
  }
}
